var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-seach-wrap"},[_c('el-tabs',{model:{value:(_vm.bannerName),callback:function ($$v) {_vm.bannerName=$$v},expression:"bannerName"}},[_c('el-tab-pane',{attrs:{"label":"广告位管理","name":"first"}})],1),_vm._v(" "),(_vm.bannerName == 'first')?_c('AD'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c98e5d1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/plus/ad/index.vue
// module id = null
// module chunks = 